import { useRef } from 'react'

import UploadsStyles from '../Uploads/Uploads.module.scss'
import ImageMenuModalStyles from '../ImageMenuModal.module.scss'

import { useConfirmModal } from 'hooks/useConfirmModal'
import { useGenerateImages } from 'components/GenerateImageDrawer/hooks/useGenerateImages'

import { Modal } from 'almanac-ui/Modal'
import { AiConfirmModal } from 'components/ImagePickerModal/AIGeneration/AiConfirmModal'
import { GenerateImageModalContent } from 'components/GenerateImageModal/GenerateImageModal'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useImageMenuContext } from '../ImageMenuContext'
import { Actions } from '../ImageMenuModal'

export const AiGeneration = () => {
  const aiConfirmProvider = useConfirmModal(AiConfirmModal)
  const containerRef = useRef<HTMLDivElement>(null)
  const props = useGenerateImages({ containerRef })
  const { setProvider, toggleSelectedImage } = useImageMenuContext()

  const showConfirmModalIfNecessary = async () => {
    if (props.generationSets.length > 0) {
      const confirm = await aiConfirmProvider()

      if (confirm) {
        setProvider('')
      }

      return
    }

    setProvider('')
  }

  return (
    <>
      <Modal.Header className={ImageMenuModalStyles.header}>
        <div className={UploadsStyles.header}>
          <Button variant="tertiary" size="xs" frontIcon={ArrowLeft} onPress={showConfirmModalIfNecessary} />
          <Heading level={3}>Generate an Image</Heading>
        </div>
        <Actions />
      </Modal.Header>
      <GenerateImageModalContent
        showExamples={false}
        containerRef={containerRef}
        onConfirm={(image) => toggleSelectedImage({ ...image, provider: 'ai' })}
        {...props}
      />
    </>
  )
}
